import { Box, FormControl } from '@mui/material'
import RegularButton from 'components/CustomButtons/Button'
import { useForm } from 'hooks/useForm'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createNewStationMunicipalities } from 'redux/actions/stationMunicipalities/stationMunicipalitiesActions'
import { AutocompleteComponent } from 'components/Autocomplete/AutocompleteComponent'
import { useToggle } from 'hooks/useToggle'
import { ModalV2 } from 'components/Modal/ModalV2'

const FIELD_VALIDATIONS = {
  station: { required: true },
  unit: { required: true },
  state: { required: true },
  municipality: { required: true },
}

export const FormStationMunicipalitiesEdit = memo((props) => {
  const { handleClose } = props
  const { station: stationSelected, stationMunStatesArr, munStatesNotAvailable } = useSelector(({ stationMun }) => stationMun)
  const { stationsList } = useSelector(({ companies }) => companies);
  const { unitsMap } = useSelector(({ unitsReducer }) => unitsReducer);
  const [isOpenAdd, handleIsOpenAdd] = useToggle();
  const [unitsOptions, setUnitsOptions] = useState([]);
  const [municipalitiesOptions, setMunicipalitiesOptions] = useState([]);
  const { inputValues, handleNewValues, fieldErrors, validate } = useForm({
    station: null,
    unit: null,
    state: null,
    municipality: null,
  }, FIELD_VALIDATIONS)
  const dispatch = useDispatch()
  const { station, unit, state, municipality } = inputValues

  const handleOpenModal = useCallback(() => {
    validate([], handleIsOpenAdd)
  }, [validate, handleIsOpenAdd])

  const handleSubmit = useCallback(() => {
    const newValues = {
      ...state,
      idState: state.id,
      state: state.name,
      station: station.name,
      idStation: station.id,
      idMunicipality: municipality.id,
      name: municipality.name,
      id: municipality.id,
    }
    
    dispatch(createNewStationMunicipalities(newValues))
    handleClose()
  }, [state, station, municipality, handleClose])

  useEffect(() => {
    if(stationSelected?.id !== station?.id) {
      const actualStation = stationSelected?.id ? stationSelected : station

      handleNewValues({
        station: actualStation,
      })
    }
    if(stationSelected?.id || station?.id) {
      const actualStation = stationSelected?.id ? stationSelected : station
      setUnitsOptions(unitsMap.filter(unit => unit.idStation === actualStation.id))
    } else {
      setUnitsOptions([])
    }
    // eslint-disable-next-line 
  }, [stationSelected, station])

  useEffect(() => {
    if(state?.municipalities) setMunicipalitiesOptions(state?.municipalities.filter(mun => !munStatesNotAvailable?.has(mun?.id)))
    // eslint-disable-next-line
  }, [state])

  return (
    <>
      <FormControl fullWidth style={{ display: 'flex', gap: 10, marginTop: 20 }}>
        <FormControl fullWidth variant="outlined">
          <AutocompleteComponent
            name="station"
            value={station}
            options={stationsList}
            label="Planta *"
            handleValues={handleNewValues}
            disabled={stationSelected?.id}
            textFieldProps={{
              error: !!fieldErrors.station,
              helperText: fieldErrors.station,
            }}
          /> 
        </FormControl>
        <FormControl fullWidth variant="outlined">
          <AutocompleteComponent
            name="unit"
            value={unit}
            options={unitsOptions}
            label="Unidad *"
            handleValues={handleNewValues}
            textFieldProps={{
              error: !!fieldErrors.unit,
              helperText: fieldErrors.unit,
            }}
          /> 
        </FormControl>
        <FormControl fullWidth variant="outlined">
          <AutocompleteComponent
            name="state"
            value={state}
            options={stationMunStatesArr}
            label="Estado *"
            handleValues={handleNewValues}
            textFieldProps={{
              error: !!fieldErrors.state,
              helperText: fieldErrors.state,
            }}
          /> 
        </FormControl>
        <FormControl fullWidth variant="outlined">
          <AutocompleteComponent
            name="municipality"
            value={municipality}
            options={municipalitiesOptions}
            label="Municipio *"
            handleValues={handleNewValues}
            textFieldProps={{
              error: !!fieldErrors.municipality,
              helperText: fieldErrors.municipality,
            }}
          /> 
        </FormControl>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1,
            marginTop: 2,
          }}
        >
          <RegularButton color="transparent" onClick={handleClose}>Cancelar</RegularButton>
          <RegularButton color="info" onClick={handleOpenModal}>Agregar</RegularButton>
        </Box>
      </FormControl>
      <ModalV2
        open={isOpenAdd}
        onClose={handleIsOpenAdd}
        justConfirm
        title={`¿Asignar el municipio "${municipality?.name}" a la unidad "${unit?.number}"?`.toUpperCase()}
        minHeight={2}
        textAlign="center"
        textMargin={28}
        onSubmit={handleSubmit}
        confirmText="Aceptar"
      />
    </>
  )
})
